import Button, {
  ButtonTypes,
} from "../../../../common/components/button/button";
import "./coverPreviewArea.scss";
import { ReactComponent as InfoIcon } from "../../../../assets/infoIcon.svg";
import Tooltip from "../../../../common/components/tooltip/tooltip";

export enum Position {
  CENTER = "Center",
  BOTTOM_CENTER = "Bottom Center",
  BOTTOM_RIGHT = "Bottom Right",
}

export default function CoverPreviewArea(props: {
  buttonText?: string;
  buttonColor?: string;
  textColor?: string;
  image?: string;
  buttonPosition?: Position;
  ratio?: string;
  style?: React.CSSProperties;
  description?: string;
  fontFamily?: string;
  infoText?: string;
}) {
  return (
    <div
      className="cover-preview-container"
      style={{
        aspectRatio: props.ratio ?? "2/1",
        ...props.style,
      }}
    >
      <div
        className="cover-preview-area"
        style={{
          backgroundImage: `url(${props.image})`,
          justifyContent:
            props.buttonPosition == Position.BOTTOM_RIGHT
              ? "flex-end"
              : "center",
        }}
      >
        <div
          style={{
            alignSelf:
              props.buttonPosition == Position.CENTER ? "center" : "flex-end",
          }}
        >
          <Button
            fontFamily={props.fontFamily}
            type={ButtonTypes.PRIMARY}
            text={props.buttonText ?? ""}
            bgColor={props.buttonColor}
            border={"0"}
          />
        </div>
      </div>
      <div className="cover-preview-description">
        {props.description}
        <Tooltip text={props.infoText}>
          <InfoIcon width={15} height={15} />
        </Tooltip>
      </div>
    </div>
  );
}
